import script from "./OrganizersView.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizersView.vue?vue&type=script&setup=true&lang=js"

import "./OrganizersView.vue?vue&type=style&index=0&id=90c5607e&scoped=true&lang=css"
import "./OrganizersView.vue?vue&type=style&index=1&id=90c5607e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90c5607e"]])

export default __exports__